module.exports = __webpack_public_path__ + "img/ahu2.1c5b46ae.jpg";